import { Component, Input } from '@angular/core';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';
import { NgTemplateOutlet } from '@angular/common';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { CapAlertListComponent } from '../../../core/extension/exceptions/cap-alert-list.component';

@Component({
  selector: 'cap-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  imports: [NgTemplateOutlet, BreadcrumbComponent, CapAlertListComponent]
})
export class ContentHeaderComponent {
  @Input()
  public disableBreadcrumb: boolean = false;
  public alertLevelContentHeader = CapAlertLevel.CONTENT_HEADER;

  constructor() {}
}
